import Image from "next/image";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./styles.module.scss";
import check from "../../../../public/svgs/check-icon.svg";
import InfoIcon from "../../../../public/svgs/InfoIcon";
import { Trans } from "react-i18next";
import { t } from "i18next";

const toastOptions = {
  position: "bottom-center" as const,
  className: styles.toastContainer,
  autoClose: 5000,
  closeButton: false,
  hideProgressBar: true,
  draggable: false,
  icon: () => <InfoIcon />,
};

export const onlineNotification = () => {
  toast.success(
    <div className={styles.toastContent}>
      <span>{t("Netzwerkverbindung wiederhergestellt.")}</span>
      <Image width={24} height={24} src={check} alt={"check box"}></Image>
    </div>,
    toastOptions
  );
};

export const offlineNotification = () => {
  toast.error(
    <div className={styles.toastContent}>
      <span>
        <Trans
          components={{
            br: <br />,
          }}
          i18nKey="Netzverbindung nicht verfügbar. Bitte überprüfen Sie Ihre Datenverbindung."
        />
      </span>
      <span className={styles.spinner}></span>
    </div>,
    toastOptions
  );
};
